<template>
    <div :style="contentStyle" style="border-radius: 50%" class="wishlist-like bg-white border-r">
        <v-btn
            size="x-small"
            color="error"
            :icon="wishlisted ? 'mdi-cards-heart' : 'mdi-cards-heart-outline'"
            variant="text"
            elevation="0"
            @click="wishlisted ? unlike() : like()"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {appInstance} from '@/utils/app-accessor'
    import {updateHotelWishlist} from '@/utils/hotels/hotel-helpers'
    import {updateActivityWishlist} from '@/utils/activities/activities-helpers'

    @Component
    export class WishlistLike extends Vue {
        @Prop() info
        @Prop() query
        @Prop() person
        @Prop() productRuntimeStore
        @Prop() inWishlist
        @Prop({default: 'position: absolute; right: 12px; top: 8px'}) contentStyle

        wishlisted = false

        async mounted() {
            if (this.userId) {
                this.wishlisted = this.inWishlist
            } else {
                const cachedOffers = (await appInstance.$localForage.getItem(`${this.query.productType}Wishlist`)) || []
                const index =
                    this.query.productType === 'hotel'
                        ? cachedOffers.findIndex(
                              ({supplierCode, cityCode, hotelCode}) =>
                                  this.query.supplierCode === supplierCode &&
                                  this.query.cityCode === cityCode &&
                                  this.query.hotelCode === hotelCode
                          )
                        : this.query.productType === 'activity'
                          ? cachedOffers.findIndex(({info}) => this.query.id === info.id)
                          : -1

                if (index >= 0) {
                    this.wishlisted = cachedOffers[index].wishlist
                } else this.wishlisted = this.inWishlist
            }
        }

        async updateCachedOffers(val) {
            const cachedOffers = (await appInstance.$localForage.getItem(`${this.query.productType}Wishlist`)) || []

            if (this.query.productType === 'hotel')
                updateHotelWishlist(cachedOffers, {...this.info, ...this.query}, val)
            if (this.query.productType === 'activity')
                updateActivityWishlist(cachedOffers, {...this.info, ...this.query}, val)
            appInstance.$localForage.setItem(`${this.query.productType}Wishlist`, clone(cachedOffers))
        }

        async like() {
            try {
                if (this.userId) {
                    await this.$api.wishlist.post({userId: this.userId, ...this.info, ...this.query})
                } else {
                    await this.updateCachedOffers(true)
                }
                this.wishlisted = true

                await this.productRuntimeStore.updateWishlist({
                    ...this.info,
                    ...this.query,
                    isWishlist: true,
                })
            } catch (e) {
                this.wishlisted = false
            }
        }

        async unlike() {
            try {
                if (this.userId) {
                    await this.$api.wishlist.remove({userId: this.userId, ...this.query})
                } else {
                    await this.updateCachedOffers(false)
                }
                this.wishlisted = false

                await this.productRuntimeStore.updateWishlist({
                    ...this.query,
                    isWishlist: false,
                })
            } catch (e) {
                this.wishlisted = true
            }
        }

        get userId() {
            return this.person?.personId
        }
    }

    export default WishlistLike
</script>
